import {
  CrudMode,
  DataDisplay,
  Grid,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import {
  SurveyResponseUpdateDto,
} from "generated/openApi";

import produce from "immer";
import "moment-timezone";

export const SurveyResponseStudentBody = (props: {
  crudMode: CrudMode;
  deleting: boolean;
  formResponse: SurveyResponseUpdateDto;
  setFormResponse: (value: SurveyResponseUpdateDto) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints, xSmallFieldBreakpoints } = useElementBreakpoints();

  const studentIdField = () => {
    return props.crudMode === "view" ? (
      <DataDisplay label="Student ID">{props.formResponse.studentId}</DataDisplay>
    ) : (
      <Input
        errors={props.validationErrors["studentId"]}
        value={props.formResponse.studentId}
        onChange={(e) =>
          props.setFormResponse(
            produce(props.formResponse, (draft) => {
              draft.studentId = e.target.value;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      {!props.deleting && (<Grid item xs={smallFieldBreakpoints}>
        {studentIdField()}
      </Grid>)}

      {props.deleting && (<Grid item xs={12}>
        <Typography  variant="inherit">Are you sure you want to delete this application response?</Typography>
      </Grid>)}
    </Grid>
  );
};
